export enum Action {
  Create = 'create',
  Read = 'read',
  Delete = 'delete',
}
